<template>
  <div class="trasferte-mobile mobile_customize col-xs-24" :style="{ height: (tableHeight) + 'px' }">

    <transition name="fade">
      <ricerca v-show="showSearchPanel" @closeRicerca="closeSearch" @cerca="cerca" @loadingOff="setLoading(false)"
        :tipoRicerca="'Trasferte_form'">
      </ricerca>

    </transition>

    <div v-show="showPrincipal">
      <div class="header-tab row row-custom">
        <div class="col-4 no-padding icon-search">
          <el-button @click="openSearch">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-button>
        </div>
        <div class="mobile-title col-16 no-padding">{{ $t('trasferte.label.title') }}</div>
        <div class="col-4 no-padding">
          <div class="add" @click="add(null)">
            <icon name="riv-add_2" scale="2" flip="horizontal" class="pointer"></icon>
          </div>
        </div>
      </div>

      <el-table :data="listaTrasferte" row-class-name="single riga-hover double" row-key="idTrasferta"
        @row-click="dettTrasferta" :empty-text="$t('trasferte.msg.noData')" v-loading="loading" class="el-table_mobile">

        <el-table-column width="30">

          <template slot-scope="scope" slot="header">
            <div class="icon-title" :key="scope.length">
              <el-popover placement="top" trigger="click">
                <div>
                  <div>
                    <icon :name="getStatoIcon('0')" class="status-saved" scale="1.2"></icon>
                    <span>{{ $t('status.0') }}</span>
                  </div>
                  <div>
                    <icon :name="getStatoIcon('1')" class="status-send" scale="1.2"></icon>
                    <span>{{ $t('status.1') }}</span>
                  </div>
                  <div>
                    <icon :name="getStatoIcon('2')" class="status-rejected" scale="1.2"></icon>
                    <span>{{ $t('status.2') }}</span>
                  </div>
                  <div>
                    <icon :name="getStatoIcon('3')" class="status-approved" scale="1.2"></icon>
                    <span>{{ $t('status.3') }}</span>
                  </div>
                  <div>
                    <icon :name="getStatoIcon('4')" class="status-send" scale="1.2"></icon>
                    <span>{{ $t('status.4') }}</span>
                  </div>
                  <div>
                    <icon :name="getStatoIcon('4')" class="status-approved" scale="1.2"></icon>
                    <span>{{ $t('status.3') }}</span>
                  </div>
                  <div>
                    <icon :name="getStatoIcon('7')" class="status-delete" scale="1.2"></icon>
                    <span>{{ $t('status.7') }}</span>
                  </div>
                </div>
                <span slot="reference">
                  <icon class="pointer" name="riv-help" scale="1"></icon>
                </span>
              </el-popover>

            </div>
          </template>

          <template slot-scope="scope">
            <div class="name-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t(getStatoDes(scope.row))" placement="top-start">
                <icon :name="getStatoIcon(scope.row.statoAvanz)" :class="getStatoClass(scope.row)" scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" :label="$t('trasferte.label.dataIn_Fin')" width="80"
          class-name="sfondino">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block">{{ scope.row.dataDal | formattaData }}</span>
              <span class="block">{{ formatPeriodo2(scope.row) }}</span>
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('trasferte.label.destinazione')">

          <template slot-scope="scope">
            <div class="name-wrapper truncate-overflow">
              {{ scope.row.desDest === undefined ? scope.row.desMan : scope.row.desDest }}
            </div>
          </template>

        </el-table-column>
        <el-table-column header-align="center" align="center" :label="$t('trasferte.label.soc')">

          <template slot-scope="scope">
            <div class="name-wrapper truncate-overflow">
              {{ scope.row.desCli }}
            </div>
          </template>

        </el-table-column>

        <el-table-column width="30">

          <template slot-scope="scope">
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent>
              <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="dettaglio(scope.row)">
                    <span>{{ $t('trasferte.label.riepilogo') }}</span>
                  </div>
                  <div @click="add(scope.row)">
                    <span>{{ $t('trasferte.label.nuova') }}</span>
                  </div>
                  <div @click="copia(scope.row)">
                    <span>{{ $t('trasferte.label.copia') }}</span>
                  </div>
                  <div @click="elimina(scope.row)">
                    <span>{{ $t('trasferte.label.annulla') }}</span>
                  </div>
                </template>

                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" background layout="prev, pager, next"
        :total="nrItems" :page-size="pag_for" @current-change="changePage" class="el-pagination_mobile" :pager-count=5>
      </el-pagination>

    </div>

    <!-- Dialog di dettaglio trasferta -->
    <div v-show="showModalDettaglio" v-loading="loadingDettaglio" class="el-form_mobile">
      <!--<el-dialog :title="($t('trasferte.label.riepilogo').toUpperCase())" :visible.sync="showModalDettaglio"
               class="el-dialog_mobile dialog-ferie-mobile mobile_customize" :append-to-body="true"
               custom-class="col-24">-->

      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="1.2" flip="horizontal"
            @click.native="closeModal('showModalDettaglio')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('trasferte.label.riepilogo') }}
        </div>
      </div>
      <div class="el-form el-form-body">
        <el-table :data="dettaglioTrasferta" row-class-name="single riga-hover" class="el-table_mobile">

          <el-table-column>

            <template slot-scope="scope">
              <div class="name-wrapper">
                {{ scope.row.giorno | formattaData }}
              </div>
            </template>

          </el-table-column>

          <el-table-column header-align="center" align="center" class-name="icona" width="50">

            <template slot-scope="scope" slot="header">
              <div class="icon-title" :key="scope.length">
                <icon name="riv-mensa" scale="1.2"></icon>
              </div>
            </template>

            <template slot-scope="scope">
              <div class="name-wrapper">
                <el-tooltip v-if="scope.row.statoMensa !== ''" class="item" effect="dark"
                  :content="$t('statusDett.' + scope.row.statoMensa)" placement="top-start">
                  <icon :name="getStatoIcon_dett(scope.row.statoMensa)"
                    :class="getStatoClass_dett(scope.row.statoMensa)" scale="0.8"></icon>
                </el-tooltip>
              </div>
            </template>

          </el-table-column>

          <el-table-column header-align="center" align="center" class-name="icona" width="50">

            <template slot-scope="scope" slot="header">
              <div class="icon-title" :key="scope.length">
                <icon name="riv-alloggio" scale="1.2"></icon>
              </div>
            </template>

            <template slot-scope="scope">
              <div class="name-wrapper">
                <el-tooltip v-if="scope.row.statoAlloggio !== ''" class="item" effect="dark"
                  :content="$t('statusDett.' + scope.row.statoAlloggio)" placement="top-start">
                  <icon :name="getStatoIcon_dett(scope.row.statoAlloggio)"
                    :class="getStatoClass_dett(scope.row.statoAlloggio)" scale="0.8"></icon>
                </el-tooltip>
              </div>
            </template>

          </el-table-column>

          <el-table-column header-align="center" align="center" class-name="icona" width="50">

            <template slot-scope="scope" slot="header">
              <div class="icon-title" :key="scope.length">
                <icon name="riv-tickets" scale="1.2"></icon>
              </div>
            </template>

            <template slot-scope="scope">
              <div class="name-wrapper">
                <el-tooltip v-if="scope.row.statoBiglietti !== ''" class="item" effect="dark"
                  :content="$t('statusDett.' + scope.row.statoBiglietti)" placement="top-start">
                  <icon :name="getStatoIcon_dett(scope.row.statoBiglietti)"
                    :class="getStatoClass_dett(scope.row.statoBiglietti)" scale="0.8"></icon>
                </el-tooltip>
              </div>
            </template>

          </el-table-column>

          <el-table-column header-align="center" align="center" class-name="icona" width="50">

            <template slot-scope="scope" slot="header">
              <div class="icon-title" :key="scope.length">
                <icon name="riv-taxi" scale="1.2"></icon>
              </div>
            </template>

            <template slot-scope="scope">
              <div class="name-wrapper">
                <el-tooltip v-if="scope.row.statoTrasporti !== ''" class="item" effect="dark"
                  :content="$t('statusDett.' + scope.row.statoTrasporti)" placement="top-start">
                  <icon :name="getStatoIcon_dett(scope.row.statoTrasporti)"
                    :class="getStatoClass_dett(scope.row.statoTrasporti)" scale="0.8"></icon>
                </el-tooltip>
              </div>
            </template>

          </el-table-column>

          <el-table-column header-align="center" align="center" class-name="icona" width="50">

            <template slot-scope="scope" slot="header">
              <div class="icon-title" :key="scope.length">
                <icon name="riv-autoPer2" scale="1.6"></icon>
              </div>
            </template>

            <template slot-scope="scope">
              <div class="name-wrapper">
                <el-tooltip v-if="scope.row.statoAutoAz !== ''" class="item" effect="dark"
                  :content="$t('statusDett.' + scope.row.statoAutoAz)" placement="top-start">
                  <icon :name="getStatoIcon_dett(scope.row.statoAutoAz)"
                    :class="getStatoClass_dett(scope.row.statoAutoAz)" scale="0.8"></icon>
                </el-tooltip>
              </div>
            </template>

          </el-table-column>


        </el-table>
      </div>

      <span slot="footer">
        <el-button class="mobile-el-button secondary" @click="closeModal('showModalDettaglio')">{{ $t('btn.annulla')
          }}</el-button>
      </span>

    </div>
    <!--</el-dialog>-->

    <!-- Dialog per la copia trasferta -->
    <div v-show="showModalCopia" class="el-form_mobile">
      <!--<el-dialog :title="($t('trasferte.label.copia').toUpperCase())" :visible.sync="showModalCopia"
               class="el-dialog_mobile dialog-ferie-mobile mobile_customize" :append-to-body="true"
               custom-class="col-24">-->

      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="1.2" flip="horizontal"
            @click.native="closeModal('showModalCopia')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('trasferte.label.copia') }}
        </div>
      </div>
      <el-form class="el-form-body">
        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.label.giornoCopia') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input type="date" v-model="trasferta.giorno" class="first" />
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="el-form-label col-12 no-padding">{{ $t('trasferte.label.referente') }}</div>
          <div class="el-form-label col-12 no-padding">
            <el-switch v-model="addManual" :active-text="$t('trasferte.label.altro')" active-color="#007c74">
            </el-switch>
          </div>
          <div class="el-form-input col-20 no-padding" v-if="addManual">
            <div class="input-wrapper">
              <input type="text" v-model="manualMail" :placeholder="$t('trasferte.label.insertMail')" />
            </div>
          </div>
          <div class="el-form-input col-4 no-padding" v-if="addManual">
            <div class="add pointer" @click="addEmail({ 'nome': '', 'mail': manualMail })" style="padding-top: 2px;">
              <icon name="riv-add_2" scale="2"></icon>
            </div>
          </div>
          <div class="el-form-input col-24 no-padding" v-if="!addManual">
            <div class="input-wrapper">
              <input type="text" v-model="filter_mail" :placeholder="$t('trasferte.label.selMail')"
                @change="listEmail" />
            </div>
          </div>
          <div class="el-form-input col-24 no-padding" v-if="!addManual">
            <div class="select-wrapper">
              <select v-model="select_mail" @change="selectEmail">
                <option v-for="(item) in tbl_mail" :value="item.Email + '#' + item.Surname + ' ' + item.Name"
                  :key="item.Email + '#' + item.Surname + ' ' + item.Name">{{ item.Email }}</option>
              </select>
            </div>
          </div>
          <div class="col-24 no-padding" style="height: 100%;">
            <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" closable :disable-transitions="false"
              @close="handleClose(tag)">
              {{ tag.mail }}
            </el-tag>
          </div>
        </div>


        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.label.motivo') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="trasferta.notaDip" class="first" rows="5" />
            </div>
          </div>
        </div>


      </el-form>

      <span slot="footer">
        <el-button :loading="loaderBtn" class="mobile-el-button primary" @click="incolla">{{
          $t('btn.salva')}}</el-button>
        <el-button :loading="loaderBtn" class="mobile-el-button secondary" @click="closeModal('showModalCopia')">{{
          $t('btn.annulla') }}</el-button>
      </span>

    </div>
    <!--</el-dialog>-->

    <!-- Dialog per la creazione di una nuova trasferta -->
    <div v-show="showModalNew" class="el-form_mobile">
      <!--<el-dialog :title="($t('trasferte.label.nuova').toUpperCase())" :visible.sync="showModalNew"
               class="el-dialog_mobile dialog-ferie-mobile mobile_customize" :append-to-body="true"
               custom-class="col-24">-->
      <div class="el-form-header row row-custom">
        <div class="el-form-action col-2 no-padding">
          <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="1.2" flip="horizontal"
            @click.native="closeModal('showModalNew')"></icon>
        </div>
        <div class="el-form-title col-20 no-padding">
          {{ $t('trasferte.label.nuova') }}
        </div>
      </div>

      <el-form class="el-form-body">
        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.tipoTrasferta') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="trasferta.tipoTrasferta">
                <option v-for="(item) in tbl_tipoTrasferta" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'GIO'">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.periodo') }}</div>
          <div class="el-form-input col-12 padding-right">
            <div class="input-wrapper">
              <input type="date" v-model="trasferta.dataDal" class="first" />
            </div>
          </div>
          <div class="el-form-input col-12 padding-left">
            <div class="input-wrapper">
              <input type="date" v-model="trasferta.dataAl" class="first" />
            </div>
          </div>
        </div>
        <div class="elemento row row-custom" v-else>
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.periodo') }}</div>
          <div class="el-form-input col-24 padding-right">
            <div class="input-wrapper">
              <input type="date" v-model="trasferta.dataDal" class="first" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
          <div class="el-form-label col-6 no-padding center">{{ $t('ferie.hhInizio') }}</div>
          <div class="el-form-label col-6 no-padding center">{{ $t('ferie.mmInizio') }}</div>
          <div class="el-form-label col-6 no-padding center">{{ $t('ferie.hhFine') }}</div>
          <div class="el-form-label col-6 no-padding center">{{ $t('ferie.mmFine') }}</div>
          <div class="el-form-input col-6 no-padding">
            <div class="select-wrapper time-first">
              <select v-model="trasferta.oraIni" @change="changeOre">
                <option v-for="(hour, index) in hours" :value="hour" :key="index">{{ hour }}</option>
              </select>
            </div>
          </div>
          <div class="el-form-input col-6 no-padding">
            <div class="select-wrapper time-first">
              <select v-model="trasferta.minutiIni" @change="changeOre">
                <option v-for="(minute, index) in minutes" :value="minute" :key="index">{{ minute }}</option>
              </select>
            </div>
          </div>
          <div class="el-form-input col-6 no-padding">
            <div class="select-wrapper time-second">
              <select v-model="trasferta.oraFin" @change="changeOre">
                <option v-for="(hour, index) in hours" :value="hour" :key="index">{{ hour }}</option>
              </select>
            </div>
          </div>
          <div class="el-form-input col-6 no-padding">
            <div class="select-wrapper time-second">
              <select v-model="trasferta.minutiFin" @change="changeOre">
                <option v-for="(minute, index) in minutes" :value="minute" :key="index">{{ minute }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'ORE'">
          <div class="el-form-label col-24 no-padding center">{{ $t('ferie.numOre') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="trasferta.oreTrasferta">
                <option v-for="(ore, index) in assenza" :value="ore" :key="index">{{ ore }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.label.partenza') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="trasferta.partenza">
                <option v-for="(item) in tbl_genSta" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-12 no-padding">{{ $t('trasferte.label.destinazione') }}</div>
          <div class="el-form-label col-12 no-padding">
            <el-switch v-model="trasferta.desCustom" :active-text="$t('trasferte.label.altro')" active-color="#007c74">
            </el-switch>
          </div>

          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper" v-show="!trasferta.desCustom">
              <!--<el-select v-model="form.destinazione" filterable allow-create>
                <el-option
                  v-for="item in tbl_genSta"
                  :key="item.id"
                  :label="item.desc"
                  :value="item.id">
                </el-option>
              </el-select>-->
              <select v-model="trasferta.destinazione">
                <option v-for="(item) in tbl_genSta" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
            <div class="el-form-input col-24 no-padding" v-show="trasferta.desCustom">
              <div class="input-wrapper">
                <input type="text" v-model="trasferta.desMan"
                  :placeholder="[$t('trasferte.label.destinazioneCustom')]" />
              </div>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom" v-show="trasferta.desCustom">
          <div class="el-form-label col-22 no-padding">
            {{ $t('trasferte.label.estera') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="trasferta.seEstero" :indeterminate="false" size="small"></el-checkbox>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.label.soc') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="trasferta.socFat" @change="loadUffRep($event.target.value)">
                <option v-for="(item) in tbl_genStaFat" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.label.uffRep') }}</div>
          <div class="el-form-input col-24 no-padding">
            <div class="select-wrapper">
              <select v-model="trasferta.uffRep">
                <option v-for="(item) in tbl_uffRep" :value="item.id" :key="item.id">{{ item.desc }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-12 no-padding">{{ $t('trasferte.label.referente') }}</div>
          <div class="el-form-label col-12 no-padding">
            <el-switch v-model="addManual" :active-text="$t('trasferte.label.altro')" active-color="#007c74">
            </el-switch>
          </div>
          <div class="el-form-input col-20 no-padding" v-if="addManual">
            <div class="input-wrapper">
              <input type="text" v-model="manualMail" :placeholder="$t('trasferte.label.insertMail')" />
            </div>
          </div>
          <div class="el-form-input col-4 no-padding" v-if="addManual">
            <div class="add pointer" @click="addEmail({ 'nome': '', 'mail': manualMail })" style="padding-top: 2px;">
              <icon name="riv-add_2" scale="2"></icon>
            </div>
          </div>
          <div class="el-form-input col-24 no-padding" v-if="!addManual">
            <div class="input-wrapper">
              <input type="text" v-model="filter_mail" :placeholder="$t('trasferte.label.selMail')"
                @change="listEmail" />
            </div>
          </div>
          <div class="el-form-input col-24 no-padding" v-if="!addManual">
            <div class="select-wrapper">
              <select v-model="select_mail" @change="selectEmail">
                <option v-for="(item) in tbl_mail" :value="item.Email + '#' + item.Surname + ' ' + item.Name"
                  :key="item.Email + '#' + item.Surname + ' ' + item.Name">{{ item.Email }}</option>
              </select>
            </div>
          </div>
          <div class="col-24 no-padding" style="height: 100%;">
            <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" closable :disable-transitions="false"
              @close="handleClose(tag)">
              {{ tag.mail }}
            </el-tag>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-24 no-padding">{{ $t('trasferte.label.motivo') }}</div>
          <div class="el-form-input col-24 no-padding" style="height: 100%;">
            <div class="input-wrapper">
              <textarea v-model="trasferta.notaDip" class="first" rows="5" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom">
          <div class="el-form-label col-22 no-padding">
            {{ $t('trasferte.label.mensa') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="trasferta.checkedMensa" :indeterminate="false"></el-checkbox>
          </div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input v-model="trasferta.notaMensa" class="first" :disabled="!trasferta.checkedMensa" />
            </div>
          </div>
        </div>

        <div class="elemento row row-custom" v-if="trasferta.tipoTrasferta === 'GIO'">
          <div class="el-form-label col-22 no-padding">
            {{ $t('trasferte.label.alloggio') }}
          </div>
          <div class="el-form-label col-2 no-padding">
            <el-checkbox v-model="trasferta.checkedAlloggio" :indeterminate="false" size="small"></el-checkbox>
          </div>
          <div class="el-form-input col-24 no-padding">
            <div class="input-wrapper">
              <input v-model="trasferta.notaAlloggio" class="first" :disabled="!trasferta.checkedAlloggio" />
            </div>
          </div>
        </div>

      </el-form>

      <span slot="footer">
        <el-button :loading="loaderBtn" class="mobile-el-button primary" @click="salva">{{ $t('btn.salva') }}</el-button>
        <el-button :loading="loaderBtn" class="mobile-el-button secondary" @click="closeModal('showModalNew')">{{
          $t('btn.annulla') }}</el-button>
      </span>

    </div>
    <!--</el-dialog>-->
  </div>
</template>

<script>
import Ricerca from './RicercaMobile.vue'
import { bus } from '../Bus.js'
import moment from 'moment'

export default {
  name: "RiepilogoTrasferteMobile",
  components: { Ricerca },
  i18n: {
    messages: {
      it_IT: {
        trasferte: {
          label: {
            title: 'Trasferta',
            periodo: 'Periodo',
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            dataIn_Fin: 'Periodo',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            destinazioneCustom: 'Altra Destinazione',
            altro: 'Altro',
            soc: 'Per Conto della Società',
            uffRep: 'Ufficio/Reparto',
            referente: 'Persona di Riferimento',
            motivo: 'Motivo',
            mensa: 'Mensa',
            alloggio: 'Alloggio',
            biglietto: 'Biglietto',
            trasporto: 'Trasporto',
            auto: 'auto Società',
            giorno: 'Giorno',
            nuova: 'Nuova Trasferta',
            riepilogo: 'Riepilogo Viaggio',
            copia: 'Copia Trasferta',
            giornoCopia: 'Giorno Inizio Trasferta',
            annulla: 'Annulla',
            estera: 'Località Estera?',
            mail: 'E-mail',
            nome: 'Nome',
            selMail: 'Ricerca e-mail tra il personale Riva',
            insertMail: 'Aggiungi un indirizzo email esterno'
          },
          msg: {
            confDelTrasferta: 'Sei sicuro di voler eliminare la Trasferta?',
            info: 'Avviso!',
            abort: 'Operazione Annullata',
            noData: 'Nessun Documento trovato',
            errorNoPeriodo: 'Inserire il periodo della Trasferta',
          }
        }
      },
      fr_FR: {
        trasferte: {
          label: {
            title: 'Deplacement',
            periodo: 'Date du-au',
            dataIn: 'Date du',
            dataFin: 'Date au',
            dataIn_Fin: 'Période',
            partenza: 'Départ',
            destinazione: 'Destination',
            destinazioneCustom: 'Autre Destination',
            altro: 'Autre',
            soc: 'pour le compte de',
            referente: 'Personne de référence',
            uffRep: 'Bureau/département',
            motivo: 'Motif',
            mensa: 'Repas',
            alloggio: 'Hébergement',
            biglietto: 'Billets Voyage',
            trasporto: 'Transport',
            auto: 'Voiture de société',
            giorno: 'Jour',
            nuova: 'Nouveau déplacement',
            riepilogo: 'Résumé du Voyage',
            copia: 'Copier Déplacement',
            giornoCopia: 'Jour de départ',
            annulla: 'Annule',
            estera: 'à l\'étranger?',
            mail: 'E-mail',
            nome: 'Nom',
            selMail: 'Recherche d\'e-mails parmi le personnel de Riva',
            insertMail: 'Ajouter une adresse e-mail externe'
          },
          msg: {
            confDelTrasferta: 'Confirmer l\'élimination?',
            info: 'Info!',
            abort: 'Opération annulée',
            noData: 'Aucun document trouvé',
            errorNoPeriodo: 'Saisir la periode du déplacement',
          }
        }
      },
      es_ES: {
        trasferte: {
          label: {
            title: 'Viaje',
            periodo: 'Fecha desde-hasta',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            dataIn_Fin: 'Período',
            partenza: 'Salida',
            destinazione: 'Destino',
            destinazioneCustom: 'Otro Destino',
            altro: 'Otro',
            soc: 'Por cuenta de la sociedad',
            referente: 'Persona de referencia',
            uffRep: 'Oficina/Empresa',
            motivo: 'Referencia',
            mensa: 'Comedor',
            alloggio: 'Alojamiento',
            biglietto: 'Ticket',
            trasporto: 'Transporte',
            auto: 'Coche de La Sociedad',
            giorno: 'Día',
            nuova: 'Nuevo',
            riepilogo: 'Resumen Viaje',
            copia: 'Copia de viaje',
            giornoCopia: 'Dia inicio viaje',
            annulla: 'Anular',
            estera: 'En el extranjero?',
            mail: 'E-mail',
            nome: 'Nombre',
            selMail: 'Búsqueda de correo electrónico entre el personal de Riva',
            insertMail: 'Agregar una dirección de correo electrónico externa'
          },
          msg: {
            confDelTrasferta: '¿Está seguro que quiere eliminar la solicitud de viaje?',
            info: '¡Aviso!',
            abort: 'Operación cancelada',
            noData: 'Sin informacion',
            errorNoPeriodo: 'Añadir periodo del viaje',
          }
        }
      },
      de_DE: {
        trasferte: {
          label: {
            title: 'Dienstreise',
            periodo: 'Datum von-bis',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            dataIn_Fin: 'Zeitraum',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            destinazioneCustom: 'Anderes Destination',
            altro: 'Andere',
            soc: 'auf Kosten der Firma',
            referente: 'Ansprechpartner',
            uffRep: 'Büro/Abteilung',
            motivo: 'Grund',
            mensa: 'Kantine',
            alloggio: 'Unterkunft',
            biglietto: 'Ticket',
            trasporto: 'Transport',
            auto: 'Firmenfahrzeug',
            giorno: 'Tag',
            nuova: 'Neue Reise',
            riepilogo: 'Zusammenfassung',
            copia: 'Kopie der Trasferta',
            giornoCopia: 'Reisebeginn',
            annulla: 'Stornieren',
            estera: 'Im Ausland?',
            mail: 'E-mail',
            nome: 'Name',
            selMail: 'E-Mail von Riva-Mitarbeitern suchen',
            insertMail: 'Externe E-Mail-Adresse hinzufügen'
          },
          msg: {
            confDelTrasferta: 'Sind Sie sicher, dass Sie den Reiseantrag löschen möchten?',
            info: 'Beachten!',
            abort: 'Operation abgebrochen',
            noData: 'Kein Dokument gefunden',
            errorNoPeriodo: 'Geben Sie den Reisezeitraum ein'
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  props: ["tableHeight"],
  data() {
    return {
      visibleInfo: false,
      loading: false,
      loadingDettaglio: false,
      showPrincipal: true,
      showSearchPanel: false,
      showModalDettaglio: false,
      showModalCopia: false,
      showModalNew: false,
      loaderBtn: false,
      form: {
        dataIn: '',
        dataFin: '',
        statoAvanz: '',
        destinazione: ''
      },
      listaTrasferte: [],
      dettaglioTrasferta: [],
      nrPages: 0,
      nrItems: 0,
      currentPage: 1,
      pag_for: 8,
      ordine: 'DD',
      /*formCopy: {
        idTrasferta: '',
        giorno: '',
        perRif: '',
        notaDip: ''
      },*/
      tbl_genSta: [],
      tbl_genStaFat: [],
      tbl_socFat: [],
      tbl_uffRep: [],
      trasferta: {},
      flagDestinazioniEstere: false,
      tbl_mail: [],
      select_mail: {},
      filter_mail: '',
      addManual: false,
      // manualNome: '',
      manualMail: '',
      check: {
        // manualNome: true,
        manualMail: true
      },
      tbl_tipoTrasferta:[],
      timeStep: '',
      hours: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23'
      ],
      minutes: ['00', '30'],
      assenza: ['00:00', '00:30', '01:00', '01:30', '02:00', '02:30', '03:00', '03:30', '04:00', '04:30', '05:00', '05:30',
        '06:00', '06:30', '07:00', '07:30', '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
        '13:00', '13:30','14:00', '14:30','15:00', '15:30','16:00', '16:30','17:00', '17:30','18:00', '18:30','19:00', '19:30',
        '20:00', '20:30','21:00', '21:30','22:00', '22:30','23:00', '23:30', '24:00']
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '') {
        return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    }
  },
  mounted: function () {
    //this.$emit('setShowNuovo', true)
    //this.initialize()
  },
  activated: function () {
    this.initialize()
  },
  methods: {
    initialize: function () {
      this.$nextTick(() => {
        if (sessionStorage.hasOwnProperty('Trasferte_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_form')))
          //this.ricerca(false)
        }
        this.loadGenSta()
        this.loadGenStaFat()
        this.loadSocfat()
        this.timeStep = '00:30' // this.country === '1' ? '00:30' : '00:05'
        this.tbl_tipoTrasferta = [
          { id: 'GIO', desc: this.$i18n.t('trasferte.tipoGio') },
          { id: 'ORE', desc: this.$i18n.t('trasferte.tipoOre') }
        ]
        this.ricerca(false)
      })
    },
    loadGenSta: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_genSta = response.body.data
            this.tbl_genSta.unshift({ desLuogo: ' ', id: '', desc: ' ', luogo: ' ' })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    loadGenStaFat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/gensta', {
        params: {
          socFat: 'Y'
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_genStaFat = response.body.data
          this.tbl_genStaFat.unshift({ desLuogo: ' ', id: '', desc: ' ', luogo: ' ' })
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    loadSocfat: function () {
      this.$http.get('datisoc/' + this.$store.state.country + '/socfat')
        .then(response => {
          if (response.body.rc === 0) {
            this.tbl_socFat = response.body.data
            this.tbl_socFat.unshift({ id: '', desc: ' ' })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        })
    },
    loadUffRep: function (value) {
      //this.trasferta.uffRep = ''
      //this.trasferta.uffRep = ''
      delete this.trasferta['uffRep']
      this.$http.get('datisoc/' + this.$store.state.country + '/uffrep', {
        params: {
          cliente: value
        }
      }).then(response => {
        if (response.body.rc === 0) {
          this.tbl_uffRep = response.body.data
          this.tbl_uffRep.unshift({ id: '', desc: ' ' })
        } else {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    closeSearch: function () {
      this.$emit('showScroll')
      this.showSearchPanel = false
    },
    openSearch: function () {
      this.showSearchPanel = true
      this.$emit('hideScroll')
    },
    cerca: function (form) {
      let formRicerca = JSON.parse(form)
      this.$set(this, 'form', formRicerca)
      this.currentPage = 1
      this.ricerca(false)
    },
    ricerca: function (flagIfChangeSort) {
      this.$set(this, 'loading', true)
      if (flagIfChangeSort === true) {
        this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_form')))
        this.currentPage = 1
      }
      let numStatiAvanz = ''
      let statoAvanz = ''
      if (this.form.statoAvanz == '' || this.form.statoAvanz == 'all') {
        statoAvanz = ''
        numStatiAvanz = "0"
      } else {
        statoAvanz = '[{"id":"' + this.form.statoAvanz + '"}]'
        numStatiAvanz = "1"
      }
      sessionStorage.setItem('Trasferte_form', JSON.stringify(this.form))
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          dataDal: (this.form.dataDal === '' || this.form.dataDal === undefined) ? '' : moment(this.form.dataDal, 'YYYY-MM-DD').format('YYYYMMDD'),
          dataAl: (this.form.dataAl === '' || this.form.dataAl === undefined) ? '' : moment(this.form.dataAl, 'YYYY-MM-DD').format('YYYYMMDD'),
          statoAvanz: statoAvanz,
          numStatiAvanz: numStatiAvanz,
          destinazione: this.form.destinazione,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: this.currentPage,
          pag_for: this.pag_for,
          pag_order: this.ordine
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            sessionStorage.setItem('Trasferte_form', JSON.stringify(this.form))
            this.listaTrasferte = response.body.data
            if (this.currentPage === 1) {
              this.$set(this, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))
            }
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.$set(this, 'listaTrasferte', [])
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)
          }
          this.closeSearch()
          this.$set(this, 'loading', false)
          /*setTimeout(() => {
            this.$set(this, 'loading', false)
          }, 500)*/
        })
    },
    dettaglio: function (row) {
      this.showPrincipal = false
      this.showModalDettaglio = true
      this.loadingDettaglio = true
      this.$http.get('trasferte/' + this.$store.state.country + '/dettaglio', {
        params: {
          idTrasferta: row.idTrasferta,
          pag_action: 'BEGIN',
          pag_from: '1',
          pag_for: '30',
          pag_order: 'DD'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.dettaglioTrasferta = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loadingDettaglio = false
          //this.loading = false
        })
    },
    elimina: function (row) {
      let _this = this
      this.$confirm(this.$i18n.t('trasferte.msg.confDelTrasferta'), this.$i18n.t('trasferte.msg.info'), {
        confirmButtonText: this.$i18n.t('btn.conferma'),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.loading = true
            let obj = {
              operazione: '*DEL',
              idTrasferta: row.idTrasferta,
              statoAvanz: row.statoAvanz
            }
            _this.$http.post('trasferte/' + _this.$store.state.country + '/trasferta', obj)
              .then(response => {
                if (response.body.rc === 0) {
                  _this.ricerca()
                } else {
                  _this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
                _this.loading = false
              })
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('trasferte.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      })
    },
    copia: function (row) {
      row = JSON.parse(JSON.stringify(row))
      this.$set(this.trasferta, 'giorno', '')
      this.$set(this.trasferta, 'contatti', row.contatti)
      this.$set(this.trasferta, 'notaDip', row.notaDip.split("\\n").join("\n"))

      this.$set(this, 'tbl_mail', [])
      this.$set(this, 'filter_mail', '')
      this.$set(this, 'select_mail', {})
      this.$set(this, 'addManual', false)
      // this.$set(this, 'manualNome', '')
      this.$set(this, 'manualMail', '')

      this.trasferta.idTrasferta = row.idTrasferta
      this.showPrincipal = false
      this.showModalCopia = true
    },
    incolla: function () {
      this.loaderBtn = true
      let obj = {
        idTrasferta: this.trasferta.idTrasferta,
        dataDal: moment(this.trasferta.giorno, 'YYYY-MM-DD').format('YYYYMMDD'),
        //'perRif': this.formCopy.perRif,
        notaDip: this.trasferta.notaDip,
        contatti: this.trasferta.contatti
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/copia', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.showModalCopia = false
            this.showPrincipal = true
            this.loaderBtn = false
            this.$router.push({ name: 'DettaglioTrasferta', params: { id: response.body.attrib.idTrasferta } })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.loaderBtn = false
          }
        })
    },
    add: function (row) {
      row = JSON.parse(JSON.stringify(row))
      this.flagDestinazioniEstere = false
      this.$set(this, 'trasferta', {})
      this.$set(this.trasferta, 'tipoTrasferta', row !== null ? row.tipoTrasferta : 'GIO')
      this.$set(this.trasferta, 'dataDal', '')
      this.$set(this.trasferta, 'dataAl', '')
      this.$set(this.trasferta, 'oraIni', '')
      this.$set(this.trasferta, 'minutiIni', '')
      this.$set(this.trasferta, 'oraFin', '')
      this.$set(this.trasferta, 'minutiFin', '')
      this.$set(this.trasferta, 'oreTrasferta', '')
      this.$set(this.trasferta, 'partenza', row !== null ? row.provenienza : '')
      this.$set(this.trasferta, 'desCustom', row !== null ? (row.desMan === undefined ? false : true) : false)
      this.$set(this.trasferta, 'destinazione', row !== null ? (row.desMan === undefined ? row.destinazione : '') : '')
      this.$set(this.trasferta, 'desMan', row !== null ? (row.desMan === undefined ? '' : row.desMan) : '')
      this.$set(this.trasferta, 'seEstero', row !== null ? (row.seEstero === undefined ? false : (row.seEstero ? 'si' : 'no')) : false)
      this.$set(this.trasferta, 'socFat', row !== null ? row.cliente : '')
      if (row !== null)
        this.loadUffRep(row.cliente)
      this.$set(this.trasferta, 'uffRep', row !== null ? row.ufficio : '')
      //this.$set(this.trasferta, 'perRif', row !== null ? row.perRif : '')
      this.$set(this.trasferta, 'contatti', row !== null ? row.contatti : [])
      this.$set(this.trasferta, 'notaDip', row !== null ? row.notaDip.split("\\n").join("\n") : '')
      this.$set(this.trasferta, 'checkedMensa', '')
      this.$set(this.trasferta, 'checkedAlloggio', '')

      this.$set(this, 'tbl_mail', [])
      this.$set(this, 'filter_mail', '')
      this.$set(this, 'select_mail', {})
      this.$set(this, 'addManual', false)
      // this.$set(this, 'manualNome', '')
      this.$set(this, 'manualMail', '')

      this.showPrincipal = false
      this.showModalNew = true
    },
    salva: function () {
      /*if (this.trasferta.periodo === undefined || this.trasferta.periodo.length !== 2) {
        this.$message({
          showClose: true,
          message: this.$i18n.t('trasferte.msg.errorNoPeriodo'),
          type: 'error',
          duration: process.env.duration
        })
      } else {*/
      this.loaderBtn = true
      /*let boolDest = false
      for(let dest in this.tbl_genSta){
        if(this.tbl_genSta[dest].id === this.trasferta.destinazione) {
          boolDest = true
          break
        }
      }*/
      let obj = {
        operazione: '*ADD',
        tipoTrasferta : this.trasferta.tipoTrasferta,
        dataDal: moment(this.trasferta.dataDal, 'YYYY-MM-DD').format('YYYYMMDD'),
        dataAl: this.trasferta.tipoTrasferta === 'ORE' ? moment(this.trasferta.dataDal, 'YYYY-MM-DD').format('YYYYMMDD') : moment(this.trasferta.dataAl, 'YYYY-MM-DD').format('YYYYMMDD'),
        oraDal: this.trasferta.tipoTrasferta === 'ORE' ? (this.trasferta.oraIni + ':' + this.trasferta.minutiIni) : '',
        oraAl: this.trasferta.tipoTrasferta === 'ORE' ? (this.trasferta.oraFin + ':' + this.trasferta.minutiFin) : '',
        oreTrasferta: this.trasferta.oreTrasferta,
        provenienza: this.trasferta.partenza,
        destinazione: this.trasferta.desCustom ? undefined : this.trasferta.destinazione,
        seEstero: this.trasferta.desCustom ? (this.trasferta.seEstero ? 'si' : 'no') : undefined,
        desMan: this.trasferta.desCustom ? this.trasferta.desMan : undefined,
        cliente: this.trasferta.socFat,
        ufficio: this.trasferta.uffRep,
        //'perRif': this.trasferta.perRif,
        notaDip: this.trasferta.notaDip,
        checkMensa: this.trasferta.checkedMensa ? 'si' : 'no',
        notaMensa: this.trasferta.notaMensa,
        checkAlloggio: this.trasferta.checkedAlloggio ? 'si' : 'no',
        notaAlloggio: this.trasferta.notaAlloggio,
        statoAvanz: '0',
        contatti: this.trasferta.contatti
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/trasferta', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loaderBtn = false
            this.showModalNew = false
            this.showPrincipal = true
            this.$router.push({ name: 'DettaglioTrasferta', params: { id: response.body.attrib.idTrasferta } })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
            this.loaderBtn = false
            // this.showPrincipal = true
          }
        })
      //}
    },
    changePage: function (page) {
      this.currentPage = page
      this.ricerca(false)
    },
    /*  Viene richiamata quando l'utente clicca sulle frecce di ordinamento della tabella. Setta il codice di ordinamento corrispondente
      *  e richiama il servizio di ricerca con questo codice
      */
    sortChange: function ({ column, prop, order }) {
      if (prop === 'dataIn') {
        if (order === 'ascending') {
          this.ordine = 'DA'
        } else if (order === 'descending') {
          this.ordine = 'DD'
        }
      } else if (prop === 'dataFin') {
        if (order === 'ascending') {
          this.ordine = 'AA'
        } else if (order === 'descending') {
          this.ordine = 'AD'
        }
      } else {
        this.ordine = 'DD'
      }
      this.ricerca(true)
    },
    dettTrasferta: function (row, event, column) {
      this.$router.push({ name: 'DettaglioTrasferta', params: { id: row.idTrasferta } })
    },
    getStatoIcon: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
        case '2':
        case '3':
          return 'riv-user'
        case '4':
          return 'riv-alloggio'
        case '7':
          return 'elm-chiudi'
        default:
          return ''
      }
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
        case '1':
        case '2':
        case '3':
        case '4':
          return 'riv-circle'
        default:
          return ''
      }
    },
    getStatoClass: function (record) {
      switch (record.statoAvanz) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === '' || record.statoAlloggio === '3') &&
            (record.statoMensa === undefined || record.statoMensa === '' || record.statoMensa === '3') &&
            (record.statoBiglietti === undefined || record.statoBiglietti === '' || record.statoBiglietti === '3') &&
            (record.statoTrasporti === undefined || record.statoTrasporti === '' || record.statoTrasporti === '3') &&
            (record.statoAutoAz === undefined || record.statoAutoAz === '' || record.statoAutoAz === '3')) {
            return 'status-approved'
          } else {
            return 'status-send'
          }
        case '7':
          return 'status-delete'
          break
        default:
          return ''
          break
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    getStatoDes: function (record) {
      switch (record.statoAvanz) {
        case '4':
          if ((record.statoAlloggio === undefined || record.statoAlloggio === '' || record.statoAlloggio === '3') &&
            (record.statoMensa === undefined || record.statoMensa === '' || record.statoMensa === '3') &&
            (record.statoBiglietti === undefined || record.statoBiglietti === '' || record.statoBiglietti === '3') &&
            (record.statoTrasporti === undefined || record.statoTrasporti === '' || record.statoTrasporti === '3') &&
            (record.statoAutoAz === undefined || record.statoAutoAz === '' || record.statoAutoAz === '3')) {
            return 'status.3'
          } else {
            return 'status.' + record.statoAvanz
          }
        default:
          return 'status.' + record.statoAvanz
          break
      }
    },
    closeModal: function (field) {
      this.$set(this, field, false)
      this.showPrincipal = true;
    },
    listEmail: function () {
      let val = this.filter_mail
      if (val.length >= 3) {
        //this.loadingDocs = true
        this.$set(this, 'tbl_mail', [])
        var obj = {
          params: {
            searchString: val,
            mailNotNull: '1'
          }
        }
        this.$http.get('{SPURL}/api/Emails', obj)
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'tbl_mail', response.body.data === null ? [] : response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: this.$i18n.t('documenti.msgSP.' + errCode),
                type: 'error',
                duration: process.env.duration
              })
              this.$set(this, 'tbl_mail', [])
            }
          })
      }
    },
    selectEmail: function () {
      let obj = {
        nome: this.select_mail.split('#')[1],
        mail: this.select_mail.split('#')[0]
      }
      this.trasferta.contatti.push(obj)
      this.filter_mail = ''
    },
    handleClose(tag) {
      this.trasferta.contatti.splice(this.trasferta.contatti.indexOf(tag), 1);
    },
    addEmail: function (val) {
      if (this.manualMail !== '') {
        this.trasferta.contatti.push(val)
        //this.manualNome = ''
        this.manualMail = ''
      } else {
        //this.check.manualNome = this.manualNome === '' ? false : true
        this.check.manualMail = this.manualMail === '' ? false : true
      }
      //this.addManual = false
    },
    formatPeriodo2: function(row) {
      if (row.tipoTrasferta === 'GIO' && row.dataAl) {
        return (row.dataAl.substr(6, 2) + '/' + row.dataAl.substr(4, 2) + '/' + row.dataAl.substr(0, 4))
      } else  if (row.tipoTrasferta === 'ORE') {
        return '(' + row.oraDal + ' - ' + row.oraAl + ')'
      }
    },
    changeOre: function () {
      if (this.trasferta.oraIni !== '' && this.trasferta.oraFin !== '' && this.trasferta.minutiIni !== '' && this.trasferta.minutiFin !== '') {
        var startTime = moment(this.trasferta.oraIni + ':' + this.trasferta.minutiIni, 'HH:mm');
        var endTime = moment(this.trasferta.oraFin + ':' + this.trasferta.minutiFin, 'HH:mm');

        // calculate total duration
        var duration = moment.duration(endTime.diff(startTime));

        // duration in hours
        var hours = parseInt(duration.asHours());
        if (hours < 10) {
          hours = '0' + hours
        }
        var minutes = parseInt(duration.asMinutes()) % 60;
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        // duration in minutes
        console.log(hours + ':' + minutes)
        this.$set(this.trasferta, 'oreTrasferta', hours + ':' + minutes)
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.trasferte-mobile {
  padding: 0;

  .header-tab {
    height: 40px;
    // border-bottom: 1px solid #007c74;
    text-align: center;
    margin-bottom: 20px;

    .icon-search {
      line-height: 40px;

      .el-button {
        height: 40px;
        width: 40px;
        border-radius: 0px;
        //margin-top: 12px;
        //margin-left: 10px;
        padding: 0px;
        color: @greenRiva;
        float: left;
        border: 1px solid @greenRiva;
      }

      .el-button:hover {
        background-color: @white;
      }
    }

    .add {
      line-height: 40px;
      // position: fixed;
      // right: 20px;
      // bottom: 20px;
      float: right;
      color: #FF791A;
      margin-right: 10px;
      margin-left: 10px;
    }
  }

  .action {
    height: 20px;
    line-height: 20px;

    span {
      float: right;
      .set-font(@size: 14px,
        @color: @grayDark,
        @weight: bold,
        @family: "os-regular"
      );
      text-transform: capitalize;
      padding-right: 15px;
    }
  }

}

.el-message-box-mobile {
  width: 98%;
}

.status-send {
  color: @orangeMedium
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.popover-mobile {
  line-height: 50px;
  .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
}

.el-form-body {
  .el-table_mobile {
    height: 100%;
    min-height: 150px;
  }
}

.el-message-box {
  width: 96% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/RiepilogoTrasferteMobile.vue